import * as React from 'react';

interface Props {
  label: string;
  children?: React.ReactNode;
}

export const RowGroup: React.FC<Props> = (props) => {
  return (
    <div className="py-4 space-y-4">
      <p className="text-gray-900 font-medium">{props.label}</p>
      <div className="ml-4">{props.children}</div>
    </div>
  );
};
